export default __webpack_public_path__ + "static/media/metamasklogo.4ca86b8d.png";